import useIntersectionObserver from "@/hooks/useIntersectionObserver";
import { classNames } from "@/lib/util";
import { Dispatch, SetStateAction } from "react";

interface InfiniteLoaderProps {
  limit: number;
  setLimit: Dispatch<SetStateAction<number>>;
  numberOfItems: number;
  fetching?: boolean;
}

const InfiniteLoader: React.FC<InfiniteLoaderProps> = ({
  limit,
  setLimit,
  numberOfItems,
  fetching,
}) => {
  useIntersectionObserver("intersection-target", [limit], (entry) => {
    // setTitleOpacity(entry.intersectionRatio);
    console.log(entry.intersectionRatio);
    if (limit >= numberOfItems) return;

    if (entry.intersectionRatio > 0) {
      setLimit(limit + 30);
    }
  });

  return (
    <div
      className={classNames(
        limit >= numberOfItems && !fetching
          ? "hidden"
          : "mt-24 flex items-center justify-center"
      )}
    >
      <div
        id="intersection-target"
        className="h-5 w-5 translate-y-[-1200px] transform-gpu rounded-full bg-blue-100"
      />
      <div className="spinner h-18 w-18" />
    </div>
  );
};

export default InfiniteLoader;
